import AgendaGridPage from './AgendaGridPage';

/**
 * Private agenda: same feature-complete grid as the public agenda, but scoped
 * to barbers flagged `is_private=true` and gated to master admins only.
 * The heavy lifting (create/edit/drag/drop/etc.) is reused from AgendaGridPage
 * via the `privateMode` prop.
 */
export default function PrivateAgendaPage() {
  return <AgendaGridPage privateMode />;
}
